$(document).ready(function() {

  $('.banner_slide-list').slick({
    dots: true,
    arrows:false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

$('.reviewBox').slick({
  dots: false,
  arrows:true,
  infinite: false,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
      }
    }
  ]
});
	
$('.featured_coll-sc .product-grid').slick({
  dots: false,
  arrows:true,
  infinite: false,
  speed: 800,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
		

  $('.offer_icon_inner').marquee({
    direction: 'left',
    duration: 13000,
    delayBeforeStart: 0,
    pauseOnHover: true,
    duplicated: true,
    startVisible: true
  });


  $('.top_bar_inner').marquee({
    direction: 'left',
    duration: 13000,
    delayBeforeStart: 0,
    pauseOnHover: true,
    duplicated: true,
    startVisible: true
  });



const ratingCount = document.querySelector('.product__info-container .review_rating');
if (ratingCount) {
  ratingCount.addEventListener('click', (e) => {
    e.preventDefault();
    const ratingSection = document.querySelector('.product__accordion.review_pro');
    const ratingTrigger = ratingSection?.querySelector(
      'button, .accordion__header, .accordion__title'
    );
    if (ratingTrigger) {
      ratingTrigger.click();
      ratingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
}

});

// custom page limit
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector('.products-per-page-wrapper');
  if (!wrapper) {
    console.log('Wrapper not found');
    return;
  }
  const select = wrapper.querySelector('#products-per-page');
  if (!select) {
    console.log('Select dropdown not found');
    return;
  }
  // Listen to SELECT change
  select.addEventListener('change', function () {
    const limit = this.value;
    let url = window.location.href;

    if (url.indexOf('?') === -1) {
      url += '?';
    }

    if (!url.includes('limit=')) {
      url += '&limit=' + limit;
    } else {
      url = url.replace(/limit=\d+/g, 'limit=' + limit);
    }

    if (!url.includes('page=')) {
      url += '&page=1';
    } else {
      url = url.replace(/page=\d+/g, 'page=1');
    }
    window.location.href = url;
  });
});



